module.exports = __webpack_public_path__ + "img/1970East-037_WEB-min.d9075788.jpg";